var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"file-btn"},[_c('div',[_vm._t("default")],2),_c('input',{ref:"inputFile",staticStyle:{"width":"100%"},attrs:{"type":"file","accept":_vm.accept},on:{"change":function($event){return _vm.FileSelected($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }